module.exports = __webpack_public_path__ + "static/img/pay-nok.ecfaa1a0.png";